import { render, staticRenderFns } from "./AltaContacto.vue?vue&type=template&id=fe6bb2e0&scoped=true&"
import script from "./AltaContacto.vue?vue&type=script&lang=js&"
export * from "./AltaContacto.vue?vue&type=script&lang=js&"
import style0 from "./AltaContacto.vue?vue&type=style&index=0&id=fe6bb2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6bb2e0",
  null
  
)

export default component.exports